// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfigST = [
  {
    title: 'Профіль',
    path: '/student/profile',
    icon: icon('ic_user'),
  },
];

export default navConfigST;
